import axiosBackEnd from "../config/axios/axios-back-end";

// Get All Application Roles api
export const getAllApplicationRolesData = async () => {
  const url = `/api/application-roles`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};

export default {
  getAllApplicationRolesData,
};
